module.exports = __webpack_public_path__ + "static/media/gem4.cefb5792.png";